// extracted by mini-css-extract-plugin
module.exports = {"headline":"ArticleHeadline_headline__Lqhre","headlineDefaultLocale":"ArticleHeadline_headlineDefaultLocale__H5pZb"};